import React from 'react';

interface CardProps {
  title?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Card = ({ title, action, children, className = '' }: CardProps) => (
  <section className={`rounded-2xl border border-slate-200/70 bg-white p-5 shadow-soft dark:bg-slate-900 dark:border-slate-800 ${className}`}>
    {(title || action) && (
      <header className="mb-3 flex items-center justify-between">
        <h3 className="text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-100">
          {title}
        </h3>
        {action}
      </header>
    )}
    {children}
  </section>
);
